import Commons from '../../../Services/Common/Common';

export const M_TCS_BASIC_Schema = {
  mapper: {
    search1: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd) || '',
      DepCd: (context) => Commons.EncryptAES(context.depCd ?? '') || '',
      Year: (context) => Commons.EncryptAES(context.currentYear ?? '') || '',
      Month: (context) => Commons.EncryptAES(context.month ?? '') || '',
      SearchText: (context) => Commons.EncryptAES('') || '',
    },
  },
};
